<template>
  <div class="products-component mb-5">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center my-auto" v-show="fetching">
          <i class="fas fa-spinner fa-spin fa-4x"></i>
        </div>
        <div class="col-12 offset-3">
          <div class="product-category">
            <h2>{{ categoryName }}</h2>
          </div>
        </div>
        <div
          v-for="(product, index) in products" :key="index"
          class="col-6 col-lg-3 mt-5"
          :class="index % 3 === 0 ? 'offset-lg-3' : ''"
          v-show="!fetching"
        >
          <Container :product="product" :active="active" v-on:get-product-slug="getProductSlug"></Container>
        </div>
      </div>
    </div>

    <ProductModal :productSlug="productSlug"></ProductModal>
  </div>
</template>

<script>
import Container from "@/components/store/ProductContainer";
import ProductModal from "@/components/store/ProductModal";

export default {
  name: "Products",
  components: {
    Container,
    ProductModal,
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    categoryName() {
      return window.location.pathname.split('/').pop().replaceAll('-', ' ');
    }
  },
  props: {
    products: Array,
    fetching: Boolean,
    productSlug: String
  },
  methods: {
    getProductSlug(slug) {
      this.$emit("get-product-slug", slug);
    },
  }
};
</script>

<style lang="sass" scoped>
.products-component
  min-height: 600px

.products
  margin-top: 5rem

.product-category
  margin-top: 2rem
  text-transform: uppercase

.btn-dutche
  text-transform: uppercase
  background-color: $dutche-primary-violet
  color: $white
  font-size: 0.9rem
  width: 250px
  border-radius: 10px

h2
  font-family: "Might Could"
  font-size: 2.25rem

.fa-4x
  font-size: 4rem
</style>
